<div class="finish">
  @if (isShowConfirmation) {
    <div class="confirmation-block">
      <svg class="block-icon">
        <use [attr.xlink:href]="svgSetIcon('shy')"></use>
      </svg>
      <p class="title">{{ 'lingo2-game-lib.title-finish-confirmation' | customLocale }} </p>
      <div class="confirmation-text">
        {{ 'lingo2-game-lib.text-finish-confirmation' | customLocale }}
      </div>
      <div class="button-wrap">
        <on-ui-button class="poutline"
          label="lingo2-game-lib.action-finish"
          (onclick)="onConfirm()">
        </on-ui-button>
        <on-ui-button class="primary"
          label="lingo2-game-lib.action-continue"
          (onclick)="onContinue()">
        </on-ui-button>
      </div>
    </div>
  } @else {
    <div class="finish-block">
      <p class="title">{{ 'lingo2-game-lib.title-finish' | customLocale }}</p>
      <div class="author-block">
        <div class="author-block__meta">
          <div class="author-block__label">{{ 'lingo2-game-lib.author' | customLocale }}:</div>
          <span (click)="openAuthorPage()" class="author-block__name">{{ authorFullName }}</span>
        </div>
      </div>
      @if (isLessonWithTasks) {
        <div class="result-block">
          <!-- если не передали ng-content -->
          <div class="result-item">
            <span class="result percent">{{ results.percent }}%</span>
            <span class="explanation">{{ 'lingo2-game-lib.label-result-percent' | customLocale }}</span>
          </div>
          <div class="result-item">
            <span class="result">{{ gradeABC }}</span>
            <span class="explanation">{{ 'lingo2-game-lib.label-result-grade' | customLocale }}</span>
          </div>
          <div class="result-item">
            <span class="result total-points">
              <svg class="result-icon">
                <use [attr.xlink:href]="svgSetIcon('star')"></use>
              </svg>
              {{ results.totalPoints }}
            </span>
            <span class="explanation">{{ 'lingo2-game-lib.label-result-points-total' | customLocale }}</span>
          </div>
        </div>
      }
      @if (!isAuthor) {
        <app-lesson-review
          [content_id]="game.content_id"
        (submitted)="onSubmitted()"></app-lesson-review>
      }
      <div class="button-wrap">
        <on-ui-button class="primary"
          label="lingo2-game-lib.action-finish"
          (onclick)="onClose()">
        </on-ui-button>
      </div>
    </div>
  }
</div>
